module.exports = "/images/awsactivate.png?3d2d6f3ef3b28399c9fe695b020da65e";